import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import { GridColDef } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, Controller, SubmitHandler } from "react-hook-form";
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import SearchChips from "../../components/SearchChips";
import { ISearchChips } from "../../interfaces/Core/ISearchChips";
import ActionMenu from "../../components/ActionMenu";
import ActionButton from "../../components/ActionButton";

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));




type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

const resolver: Resolver<IFormInput> = async (values) => {
  return {
    values: values.Name ? values : {},
    errors: !values.Name
      ? {
        Name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

export default function PatchingList() {

  function DownloadClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={DownloadClicked} buttonLabel="DOWNLOAD REPORT" />,
    
  ];


  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Inventory",
      backgroundPath: "/assets/images/inventorybg.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<IInventoryRow[]>([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Trays`)
      .then(res => {
        setRows(res.data);
      })
  }, []);



  const { register, handleSubmit, control, formState: { errors } } = useForm<IFormInput>({ resolver });

  const onSubmit: SubmitHandler<IFormInput> = data => {
    axios.post(`${process.env.REACT_APP_ENDPOINT}/api/PatchingLists`, {
      name: data.Name, generation: data.Type, assignedTo: data.Crew
    }).then((data) => {
      if (data.status === 200) {
        setOpen(false);
      };
    });
  };

  
  const [helpOpen, setHelpOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickSupport = () => {
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };



  const columns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 130 },
    { field: 'size', headerName: 'Size', width: 130 },
    { field: 'species', headerName: 'Species', width: 130 },
    { field: 'variety', headerName: 'Variety', width: 130, },
    { field: 'color', headerName: 'Color', width: 120, },
    { field: 'barcode', headerName: 'Barcode', width: 120, },
  ];

  interface IInventoryRow {
    name: string,
    status: string,
    patchweek: number,
    generation: string
  }

  // const rows = [
  //   { id: 1, name: 'Snow', status: 'Jon', location: 35, patching_week: 5, patching_year: 10, projected_completion: 'testing' },
  // ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  function valuetext(value: number) {
    return `${value}°C`;
  }

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const [searchInformation, setSearchInformation] = React.useState<ISearchChips>({year: 2023, weeks: []});
  const handleSearchChips = (searchInformation: ISearchChips) => {
    console.log("Testing", searchInformation)
    setSearchInformation(searchInformation);
    // GetPatchingLists();
  }

  return (
    <div>
     <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010" >
        <ThemeProvider theme={darkTheme}>
          <SearchChips handleSearch={handleSearchChips}></SearchChips>
        </ThemeProvider>
        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 135px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                checkboxSelection
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>

      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle>
            Need Support?
          </DialogTitle>
          <DialogContent dividers>
            <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
              If you are having issues or have questions, please contact us below.
            </Typography>
            <Button size='large' fullWidth variant="outlined" color='inherit' startIcon={<SmartphoneIcon />} sx={{ mb: 1 }}>
              <Typography variant='h6' fontWeight={700}>800-314-1797</Typography>
            </Button>
            <Button size='large' fullWidth variant="outlined" color="inherit" startIcon={<EmailIcon />}>
              <Typography variant='h6' fontWeight={700}>support@idatp.com</Typography>
            </Button>
          </DialogContent>
        </Dialog>
      </div>

      <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>Create a new patching List</DialogTitle>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <DialogContentText>
              Please fill out the following fields to continue:
            </DialogContentText>

            <Item>
              <TextField
                required
                variant="filled"
                fullWidth
                id="patchinglistname"
                label="Patching List Name"
                {...register("Name")} />
            </Item>
            <Item>
              <Controller
                control={control}
                name="Type"
                // defaultValue={ patchingListTypes[0].label }
                render={({ field: { ref, onChange, ...field } }) => (
                  <Autocomplete
                    options={patchingListTypes}
                    getOptionLabel={(option) => option.label}
                    onChange={(_, data) => {
                      return onChange(data?.value);
                    }}
                    // defaultValue={[patchingListTypes[0]]}
                    renderInput={(params) => (
                      <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Select a Type"></TextField>
                    )}
                  />
                )}
              />
            </Item>
            <Item>
              <Controller
                control={control}
                name="Crew"
                // defaultValue={ patchingListTypes[0].label }
                render={({ field: { ref, onChange, ...field } }) => (
                  <Autocomplete
                    options={crews}
                    getOptionLabel={(option) => option.label}
                    onChange={(_, data) => {
                      return onChange(data?.value);
                    }}
                    // defaultValue={[patchingListTypes[0]]}
                    renderInput={(params) => (
                      <TextField {...params} {...field} fullWidth inputRef={ref} variant="filled" label="Select a Crew"></TextField>
                    )}
                  />
                )}
              />
            </Item>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type='submit' variant="contained" color="success">Create</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>


  );
}

const patchingWeeks = [
  { label: 'Week One', type: 'week_one' },
  { label: 'Week Two', type: 'week_two' },
  { label: 'Week Three', type: 'week_three' },
  { label: 'Week Four', type: 'week_four' },
];

interface IPatchingListType {
  label: string;
  type: string;
}

const patchingListTypes = [
  { label: 'Generation 1', value: 'gen_one' },
  { label: 'Generation 2', value: 'gen_two' },
  { label: 'Manual', value: 'manual' },
  { label: 'Blow Out', value: 'blow_out' },
];

const crews = [
  { label: 'Crew A', value: '1' },
  { label: 'Crew B', value: '2' },
  { label: 'Crew C', value: '3' },
  { label: 'Crew D', value: '4' },
];

const marks = [
  {
    value: 0,
    label: 'WK1',
  },
  {
    value: 5,
    label: 'WK2',
  },
  {
    value: 10,
    label: 'WK3',
  },
  {
    value: 15,
    label: 'WK4',
  },
];
